import React from 'react';
import { Tooltip } from 'antd';
import { TooltipProps } from 'antd/lib/tooltip';
import styles from './IconButton.styl';

interface IconButtonProps extends React.PropsWithChildren<{}> {
    disabled?: boolean;
    className?: string;
    onClick?: (...items: any[]) => void;
    title?: string;
    tooltip?: string | React.ReactNode;
    tooltipProps?: Partial<TooltipProps>;
    style?: React.CSSProperties;
    overlay?: boolean;
    center?: boolean;
}

const defaultStyle: React.CSSProperties = {
    cursor: 'pointer',
};

const disableStyle: React.CSSProperties = {
    cursor: 'not-allowed',
};

const IconButton: React.FunctionComponent<IconButtonProps> = (props) => {
    const {
        children,
        tooltip,
        tooltipProps,
        style,
        center,
        onClick,
        disabled = false,
        className = '',
        title = '',
        overlay = true,
    } = props;

    const handleClick = (...args: Array<any>) => {
        if (!disabled && onClick) {
            onClick(...args);
        }
    };

    let myStyle = disabled ? disableStyle : defaultStyle;
    myStyle = {
        ...myStyle,
        ...style,
    };

    const classNames = [styles.button];
    if (center === true) {
        classNames.push(styles.center);
    }
    if (className) {
        classNames.push(className);
    }

    const button = disabled ? (
        <div className={className} style={myStyle}>
            {children}
        </div>
    ) : (
        <div
            role="button"
            tabIndex={0}
            className={classNames.join(' ')}
            style={myStyle}
            title={title}
            onClick={handleClick}
        >
            {children}
            {overlay && <div className={styles.overlay} />}
        </div>
    );
    return tooltip ? (
        <Tooltip title={tooltip} {...tooltipProps}>
            {button}
        </Tooltip>
    ) : (
        button
    );
};

export default IconButton;
